import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  PLATFORM_ID,
  Inject,
  HostListener,
} from "@angular/core";
import { OrderService } from "../../../shared/services/order.service";
import { UserService } from "../../../shared/services/user.service";
import { isPlatformBrowser } from "@angular/common";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "../../../shared/services/common.service";
import {
  Router,
} from "@angular/router";
@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
})
export class NotificationsComponent implements OnInit {
  notificationsList: any[] = [];
  userLogedIn: boolean = false;
  currentUser: any;
  user_img = "";
  existImg: boolean = false;
  nodata: boolean = false;
  user_full_name = "";
  usre_id: any;
  delete_notification_id = "";
  page_name =
    localStorage.getItem("front-lang") == "ar" ? "الإشعارات" : "Notifications";
  loading = true;
  @ViewChild("newsletter", { static: false }) NewsLetterModal: TemplateRef<any>;

  step1: boolean = false;
  step2: boolean = false;
  step3: boolean = false;

  public closeResult: string;
  public modalOpen: boolean = false;
  urlimage = this.Commen._ImageUrl + "products/thumbs/";
  currentUrl: string = "";
  hostName: string = "";
  constructor(
    public user: UserService,
    private Commen: CommonService,
    private orderService: OrderService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalService: NgbModal
  ) {
    // SET TITLE
    this.Commen.setTitle(this.page_name);
  }

  ngOnInit(): void {
    this.checkOuth();

    this.getNotificationsList();

    this.hostName = this.Commen.getDomainFromUrl();
    this.currentUrl = `https://${this.hostName}/pages/notifications`;
  }

  getNotificationsList() {
    this.loading = true;
    this.notificationsList = [];
    this.nodata = false;
    this.Commen.getNotificationsList(1000).subscribe((data) => {
      if (data.data) {
        this.notificationsList = data.data;
        // //console.log('notification list', this.notificationsList);

        this.nodata = false;
        this.loading = false;
      } else {
        this.notificationsList = [];
        this.nodata = true;
        this.loading = false;
      }
    });
  }

  checkOuth() {
    if (this.user.getToken() !== null) {
      this.userLogedIn = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser.id;
      this.user_img = this.currentUser.img;
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_full_name = this.currentUser.user_name;
    } else {
      this.userLogedIn = false;
      this.currentUser = null;
      this.usre_id = "";
      this.existImg = false;
      this.user_img = "";
    }
  }

  openModal(notification_id) {
    // this.step1=false;
    // this.step2=false;
    // this.step3=false;
    // this.delete_notification_id = '';
    // if (notification_id != '' && notification_id > 0) {
    //   this.step1=true;
    //   this.step2=false;
    //   this.step3=false;
    //   this.delete_notification_id = notification_id;
    //   if (isPlatformBrowser(this.platformId)) { // For SSR
    //     this.modalService.open(this.NewsLetterModal, {
    //       size: 'lg',
    //       ariaLabelledBy: 'NewsLetter-Modal',
    //       centered: true,
    //       windowClass: 'theme-modal newsletterm NewsLetterModal'
    //     }).result.then((result) => {
    //       this.modalOpen = true;
    //       `Result ${result}`
    //     }, (reason) => {
    //       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //     });
    //   }
    // }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  deleteNotification() {
    if (this.delete_notification_id != "") {
      this.step1 = false;
      this.step2 = true;
      this.step3 = false;

      if (this.userLogedIn == true) {
        let body = {
          notification_id: this.delete_notification_id,
        };

        this.Commen.deleteNotification(body).subscribe((data) => {
          if (data.success) {
            this.step1 = false;
            this.step2 = false;
            this.step3 = true;
            this.getNotificationsList();
          } else {
            return;
          }
        });
      } else {
        // this.router.navigate(["/pages/login"]);
        this.goToLogin();
      }
    }
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }

  loginclicked: boolean = false;

  // goToLogin() {
  //   this.loginclicked = true;
  // }
  // close() {
  //   this.loginclicked = false;
  // }

  step5Reached: boolean = false;
  stepSuccessReached: boolean = false;
  timeoutId: any;

  @ViewChild("login") loginSection;
  @ViewChild("loginFast") loginFast;

  goToLogin() {
    this.loginclicked = true;
  }

  close() {
    this.loginclicked = false;
    this.step5Reached = false;
    this.clearTimeout();
    if (this.stepSuccessReached) {
      window.location.reload();
    }
  }

  onStep5Reached() {
    this.step5Reached = true;
    this.startTimeout();
  }
  onstepSuccessReached() {
    this.stepSuccessReached = true;
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.close();
    }, 2000);
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.loginFast || !this.loginSection) {
      return;
    }
    const clickedInside = this.loginFast.nativeElement.contains(event.target);
    const clickedButton = this.loginSection.nativeElement.contains(
      event.target
    );

    if (clickedInside && this.loginclicked) {
      if (this.step5Reached) {
        this.close();
      }
    } else if (!clickedInside && clickedButton && this.loginclicked) {
      this.close();
    }
  }
}
